var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVirtualCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 449,
    height: 312,
    viewBox: "50 44 449 312",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_329_40673)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_329_40673)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 52,
    width: 337,
    height: 200,
    rx: 12,
    fill: "#001929"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237,
    y: 29.8203,
    width: 411.533,
    height: 562.35,
    transform: "rotate(-51.222 237 29.8203)",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 36.8203,
    width: 411.533,
    height: 562.35,
    transform: "rotate(-51.222 208 36.8203)",
    fill: "#003353",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171,
    y: 36.8203,
    width: 411.533,
    height: 562.35,
    transform: "rotate(-51.222 171 36.8203)",
    fill: "#003353",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 51.8203,
    width: 411.533,
    height: 562.35,
    transform: "rotate(-51.222 153 51.8203)",
    fill: "#003353",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_329_40673)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90 74.9531C87.985 74.9531 86.1255 75.6185 84.6259 76.7435V73H81V83.1562H84.6919C85.096 80.5742 87.3181 78.599 90 78.599C92.9681 78.599 95.3741 81.0182 95.3741 84.0026C95.3741 86.6536 93.4757 88.8594 90.9712 89.3177V93C95.4842 92.513 99 88.6706 99 84.0026C99 79.0052 94.9701 74.9531 90 74.9531Z",
    fill: "#E6F2FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8548 85H81C81.4784 89.2698 85.0538 92.6536 89.533 93.0503V89.3703C87.1639 89.0141 85.2828 87.2498 84.8548 85Z",
    fill: "#0070AA"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345.34 52.2541C407.996 55.3401 443.454 111.579 473.484 157.257C498.51 195.323 501.143 236.166 493.88 278.192C484.207 334.16 487.621 403.091 426.567 428.722C362.07 455.799 281.947 427.319 220.334 393.03C163.916 361.631 120.458 312.426 118.881 257.485C117.483 208.788 173.911 180.041 213.198 144.437C253.993 107.466 283.431 49.2049 345.34 52.2541Z",
    fill: "url(#paint0_linear_329_40673)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_329_40673",
    x: 0,
    y: 0,
    width: 449,
    height: 312,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 28
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_329_40673"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_329_40673",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_329_40673",
    x1: 504,
    y1: 67,
    x2: 293.919,
    y2: 434.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0070AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.364583,
    stopColor: "#0070AA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_329_40673"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 52,
    width: 337,
    height: 200,
    rx: 12,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_329_40673"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(80 73)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVirtualCard);
export default __webpack_public_path__ + "static/media/VirtualCard.18803a00305e21aefe8d5a6b625d3277.svg";
export { ForwardRef as ReactComponent };